import script from "./FormEditarTarefa.vue?vue&type=script&setup=true&lang=js"
export * from "./FormEditarTarefa.vue?vue&type=script&setup=true&lang=js"

import "./FormEditarTarefa.vue?vue&type=style&index=0&id=e1b29f5c&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-e1b29f5c"]])

export default __exports__